/* eslint-disable prettier/prettier */
import color from "constants/color";
import materialUI from "material-UI";
import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: auto; /* Adjusted to accommodate the button */
  display: flex;
  flex-direction: column; /* Changed to column to stack elements */
  align-items: center;
  border-top-right-radius: 1rem;
  border-top-left-radius: 1rem;
  background-color: #ffffff;
`;

export const Stepper: any = styled(materialUI.Stepper)`
  width: 100%;
  margin-top: 24px;
  opacity: ${(props: any) => (props.isDisabled ? 0.5 : 1)};
  pointer-events: ${(props: any) => (props.isDisabled ? "none" : "auto")};

  .MuiStepLabel-labelContainer {
    order: 1;
    .MuiStepLabel-label {
      margin-top: 0;
      margin-bottom: 6px;
      font-size: 12px;
      line-height: 12px;
      letter-spacing: 0.015em;
      color: ${color.VivazBlack};
      ${(props: any) =>
    props.isDisabled &&
    `
        color: ${color.Primary50}; // Ajuste a cor conforme necessário
      `}
    }
  }

  .MuiStepLabel-iconContainer {
    order: 2;
    svg {
      color: ${color.Primary50};
    }
    .MuiStepIcon-text {
      display: none;
    }
    &.Mui-active,
    &.Mui-completed {
      svg {
        color: ${color.primary};
      }
      ${(props: any) =>
    props.isDisabled &&
    `
        svg {
          color: ${color.Primary50};
        }
      `}
    }
  }

  .MuiStepConnector-horizontal {
    top: calc(50% + 9px);
    left: calc(-50% + 11px);
    right: calc(50% + 7px);
    transform: translateY(-50%);
    .MuiStepConnector-line {
      border-top-width: 10px;
      border-color: ${color.Primary50};
    }
    &.Mui-active,
    &.Mui-completed {
      .MuiStepConnector-line {
        border-color: ${color.primary};
        ${(props: any) =>
    props.isDisabled &&
    `
          border-color: ${color.Primary50};
        `}
      }
    }
  }
`;

export const Line = styled.div`
  width: 100%;
  height: 1px;
  margin-top: 16px;
  background-color: ${color.Primary50};
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const ButtonRow = styled.div`
  display: flex;
  width: 100%;
  margin-top: 4px;
  .button-placeholder {
    flex: 1;
    display: flex;
    justify-content: center;
  }
`;

export const Row = styled.div`
  display: flex;
  margin: 26px 16px 0px 16px;
  flex-direction: row;
  &.steps-row {
    width: 100%;
    margin: 0;
    padding: 5px;
  }
  @media only screen and (max-width: 1000px) {
    flex-direction: column;
  }
`;

export const Button = styled.button`
  padding: 6px 8px;
  background-color: #eaefff;
  color: #2d5bff;
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 15.6px;
  letter-spacing: -0.01em;
  text-align: center;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const TextLabel = styled.p`
  //styleName: XS/Medium;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  color: #424248;
`;

export const CustomIconRoot = styled.div`
  color: ${color.Primary50};
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${color.primary};
`;

export const CustomIconRootAfter = styled.div`
  color: ${color.Primary50};
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #eaefff;
`;
